/**
 * Attaches ngx-ui-tour anchor ids to sidebar menu nodes loaded from the API
 * so the agency "admin settings" tour can highlight Tools, Wallet, and System configuration.
 * Only the first matching node per anchor is tagged (avoids duplicate registration).
 */
export function applyAgencySettingsTourMenuAnchors(menu: any[]): void {
    if (!menu?.length) {
        return;
    }

    const flags = { tour2: false, tour3: false, tour4: false };

    const walk = (nodes: any[]): void => {
        if (!nodes?.length) {
            return;
        }
        for (const item of nodes) {
            const url = item.url ? String(item.url) : '';
            const title = String(item.title || '')
                .trim()
                .toLowerCase();
            const tr = String(item.translate ?? '')
                .trim()
                .toLowerCase();

            if (!flags.tour3 && (url === '/wallet' || url.startsWith('/wallet/'))) {
                item.tourAnchor = 'agency-admin-settings-tour-3';
                flags.tour3 = true;
            } else if (
                !flags.tour4 &&
                (url === '/system-configurations' || url.startsWith('/system-configurations/'))
            ) {
                item.tourAnchor = 'agency-admin-settings-tour-4';
                flags.tour4 = true;
            } else if (
                !flags.tour2 &&
                item.type === 'collapsable' &&
                (title === 'tools' || tr === 'tools')
            ) {
                item.tourAnchor = 'agency-admin-settings-tour-2';
                flags.tour2 = true;
            } else if (!flags.tour2 && (url === '/tools' || url === '/tools/')) {
                item.tourAnchor = 'agency-admin-settings-tour-2';
                flags.tour2 = true;
            } else if (
                !flags.tour4 &&
                item.type === 'collapsable' &&
                ((title.includes('system') && title.includes('config')) ||
                    (tr.includes('system') && tr.includes('config')))
            ) {
                item.tourAnchor = 'agency-admin-settings-tour-4';
                flags.tour4 = true;
            } else if (!flags.tour3 && (title === 'wallet' || tr === 'wallet')) {
                item.tourAnchor = 'agency-admin-settings-tour-3';
                flags.tour3 = true;
            }

            if (item.children?.length) {
                walk(item.children);
            }
        }
    };

    walk(menu);
}
